export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.combined-invoices-report.index`,
        path: `/${prefix}/${pre}/combined-invoices-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.combined-invoice-report.index`,
                PageDescription: "Accounts/Finance Reports: Combined Invoice report",
            },
        },
    },
];